const getters = {
    recurringObj: state => state.state.recurringObj,
    priceObj : state => state.state.priceObj,
    personalInfo2: state => state.state.personalInfo2,
}

export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js